export const URL_AUTH_LOGIN = "/auth/login";
export const URL_AUTH_FORGOT_PASSWORD = "/auth/forgot-password";

export const URL_NOT_FOUND = "/error/404";

export const URL_MAIN = "/main";
export const URL_PROFILE = "/profile";
export const URL_PROFILE_OVERVIEW = "/profile/overview";
export const URL_PROFILE_SECURITY = "/profile/security";

export const URL_NEWS = "/news";
export const URL_NEWS_DETAILS = "/news/:newsId";
export const URL_NEWS_CREATE = "/news/create";
export const URL_NEWS_UPDATE = "/news/update/:newsId";

export const URL_NOTIFICATIONS = "/notifications";
export const URL_NOTIFICATIONS_CREATE = "/notifications/create";

export const URL_QUESTIONS = "/questions";
export const URL_QUESTIONS_CREATE = "/questions/create";
export const URL_QUESTIONS_UPDATE = "/questions/update/:questionId";
export const URL_QUESTIONS_CATEGORY_CREATE = "/questions/category/create";

export const URL_VIDEO_LESSONS = "/video-lessons";
export const URL_VIDEO_LESSONS_QUESTIONS_CREATE =
  "/video-lessons/:videoLessonId/questions/create";
export const URL_VIDEO_LESSONS_QUESTIONS =
  "/video-lessons/:videoLessonId/questions";

export const URL_FAQ = "/faq";
export const URL_FAQ_CREATE = "/faq/create";
export const URL_FAQ_UPDATE = "/faq/update/:faqId";
export const URL_FAQ_CATEGORY_CREATE = "/faq/category/create";

export const URL_USERS = "/users";

export const URL_SOS = "/sos";
export const URL_SOS_DETAILS = "/sos/:userId";

export const URL_VICTIM = "/victim";
export const URL_VICTIM_DETAILS = "/victim/:victimId";

export const URL_VICTIM_STATUS_CREATE = "/victim/status/create";
export const URL_VICTIM_TYPE_CREATE = "/victim/type/create";

export const URL_CHAT = "/chat";

export const URL_SOS_PLACE = "/places-sos";

export const URL_BANNER = "/banner";
export const URL_BANNER_CREATE = "/banner/create";
export const URL_BANNER_UPDATE = "/banner/update/:bannerId";

export const URL_COURSES = "/courses";
export const URL_COURSES_CREATE = "/courses/create";
export const URL_COURSES_UPDATE = "/courses/update/:courseId";
export const URL_COURSES_LESSON = "/courses/:courseId/lesson";
export const URL_COURSES_LESSON_CREATE = "/courses/:courseId/lesson/create";
export const URL_COURSES_LESSON_UPDATE =
  "/courses/:courseId/lesson/update/:lessonId";
export const URL_COURSES_LESSON_RESOURCE_CREATE =
  "/courses/:courseId/lesson/:lessonId/resource/create";

export const URL_COURSES_TEST_CREATE =
  "/courses/:courseId/lesson/:lessonId/test/create";
export const URL_COURSES_TEST_QUESTION_CREATE =
  "/courses/:courseId/lesson/:lessonId/test/:testId/question/create";

export const URL_ABOUT_PROJECT = "/about-project";
export const URL_TEAM = "/team";
export const URL_TEAM_MEMBER_CREATE = "/team/create";
export const URL_TEAM_MEMBER_UPDATE = "/team/update/:memberId";

export const URL_VOTE_CATEGORY = "/vote-category";
export const URL_VOTE_CATEGORY_CREATE = "/vote-category/create";
export const URL_VOTE_CATEGORY_UPDATE = "/vote-category/update/:categoryId";
export const URL_VOTE_REQUESTS = "/vote-category/vote-request";
export const URL_VOTE_REQUEST_VIEW = "/vote-category/vote-request/:requestId";

export const URL_VOTE_QUESTION_CREATE =
  "/vote-category/update/:categoryId/question/create";
